import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  { n: "01", t: "Clarity over hype", d: "Property is India's biggest emotional purchase. I cut through broker-speak and give you the real numbers so you decide with your head, not FOMO." },
  { n: "02", t: "Tools, not opinions", d: "Every claim I make, you can verify. The calculators here run the exact same math banks and CAs use — EMI, eligibility, GST, TDS, capital gains." },
  { n: "03", t: "First-timers first", d: "No jargon, no gatekeeping. Whether it's your first flat or first investment, you leave understanding exactly what you're signing up for." },
];

export function Manifesto() {
  return (
    <section className="relative border-t border-border py-24 md:py-36" data-testid="manifesto">
      <div className="container-px mx-auto max-w-[1600px]">
        <Reveal>
          <p className="mb-16 font-mono text-xs uppercase tracking-[0.3em] text-cyan">The Philosophy</p>
        </Reveal>
        <div className="grid gap-16 lg:grid-cols-[1fr_1.4fr] lg:gap-24">
          <Reveal>
            <div className="relative">
              <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1000" alt="Handing over the keys to a new home"
                className="aspect-[3/4] w-full object-cover" />
              <div className="absolute -bottom-px left-0 h-1 w-24 bg-cyan" />
            </div>
          </Reveal>
          <div className="space-y-14">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="flex gap-6 border-b border-border pb-14">
                  <span className="font-mono text-sm text-cyan">{c.n}</span>
                  <div>
                    <h3 className="font-display text-3xl font-extrabold uppercase leading-none text-foreground md:text-5xl">{c.t}</h3>
                    <p className="mt-5 max-w-xl text-muted-foreground">{c.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
